import axios from 'axios'
import * as util from '@/utils'

let defaultPageSize = 10
export const getProducts = (page, type, content, size) => {
  let params = {
    page: page,
    search_type: type,
    search_content: content,
    size: size || defaultPageSize,
    t: new Date().getTime()
  }
  return axios.get(`skus`, { params: params })
}

export const getProduct = sku => {
  return axios.get(`skus/${sku}`)
}

export const getOrders = (page, content, size, bdate, edate) => {
  let params = {
    search_content: content,
    page: page,
    size: size || defaultPageSize,
    bdate: bdate,
    edate: edate
  }
  return axios.get(`orders`, { params: params })
}

export const getOrderDetail = (id, page, content, size) => {
  return axios.get(`orders/${id}/records`, {
    params: {
      search_content: content,
      page: page,
      size: size || defaultPageSize
    }
  })
}

export const getUsers = (page, content, size) => {
  let params = {
    page: page,
    search_content: content,
    size: size || defaultPageSize
  }
  return axios.get(`accounts`, { params: params })
}

export const getUser = id => {
  return axios.get(`accounts/${id}`)
}

export const resetPwd = id => {
  return axios.put(`accounts/${id}/password`)
}

export const deleteAccount = id => {
  return axios.delete(`accounts/${id}`)
}

export const accountType = () => {
  return axios.get(`others/store_types`)
}

export const login = (name, pwd) => {
  return axios.post(`tokens`, {
    username: name,
    password: pwd
  })
}

export const logout = () => {
  return axios.delete(`tokens`)
}

export const getInfo = () => {
  return axios.get(`others/login_info`)
}

export const plans = (page, size) => {
  return axios.get(`plans`, {
    params: {
      page: page,
      size: size || defaultPageSize,
      t: new Date().getTime()
    }
  })
}

// export const addUser = (name, type, location, code) => {
//   return axios.post(`accounts`, {
//     username: name,
//     type,
//     location,
//     location_code: code
//   })
// }


export const addUser = (params,account_id) => {
  return account_id ? axios.post(`accounts/${account_id}`, params) : axios.post(`accounts`, params)
}


export const addSubsidiary = (name, code, description, vechain_url) => {
  return axios.post(`subsidiaries`, {
    name: name,
    code: code,
    description: description,
    vechain_url: vechain_url
  })
}
export const addChannel = (name, code, description) => {
  return axios.post(`channels`, {
    name: name,
    code: code,
    description: description
  })
}

export const changePwd = (oldPwd, newPwd,code) => {
  return axios.put('others/password', {
    old_password: util.encrypt(oldPwd),
    new_password: util.encrypt(newPwd),
    code:code
  })
}

export const getStores = (page, size) => {
  return axios.get(`stores`, {
    params: {
      page: page,
      size: size || defaultPageSize,
      t: new Date().getTime()
    }
  })
}

export const getStore = id => {
  return axios.get(`stores/${id}`)
}

export const updateStore = (params,store_id) => {
  return axios.post(`stores/${store_id}`, params) 
}

export const getChannel = (page, size) => {
  return axios.get(`channels`, {
    params: {
      page: page,
      size: size || defaultPageSize,
      t: new Date().getTime()
    }
  })
}
export const getSubsidiary = (page, size) => {
  return axios.get(`subsidiaries`, {
    params: {
      page: page,
      size: size || defaultPageSize,
      t: new Date().getTime()
    }
  })
}

export const getSubsidiaryInfo = (code) => {
  return axios.get(`subsidiary/${code}`)
}

const getDBTodayDatas = () => {
  return axios.get(`dashboard/today_order_info`)
}

const getDBReturnDatas = () => {
  return axios.get(`dashboard/store_return_distribute`)
}

export const getDBTodayAllDatas = () => {
  return axios.all([getDBTodayDatas(), getDBReturnDatas()])
}
// datas needed in dashboard
const get30DaysOrder = () => {
  return axios.get(`dashboard/order_30days_distribute`)
}

// const get30DaysCategory = () => {
//   return axios.get(`dashboard/sku_category_distribute`)
// }

const get30DaysSKU = () => {
  return axios.get(`dashboard/vechain_id_sku_distribute`)
}

export const getDBHistoryDatas = () => {
  return axios.all([get30DaysOrder(), get30DaysSKU()])
}

export const getAdmins = (page, size) => {
  return axios.get(`admins`, {
    params: {
      page: page,
      size: size || defaultPageSize,
      t: new Date().getTime()
    }
  })
}
export const getAdmin = id => {
  return axios.get(`admins/${id}`)
}
export const getManagedAdminTypes = id => {
  return axios.get(`others/managed_admin_types`)
}
export const getManagedSubsidiaryScope = id => {
  return axios.get(`others/managed_subsidiary_scope`)
}
export const getManagedChannelScope = id => {
  return axios.get(`others/managed_channel_scope`)
}
export const addAdmin = (params,admin_id) => {
  return admin_id ? axios.post(`admins/${admin_id}`, params) : axios.post(`admins`, params)
}
export const resetAdminPwd = id => {
  return axios.put(`admins/${id}/password`)
}
export const cancelOrder = order_num => {
  return axios.delete(`orders/${order_num}`);
}
export const sendSms = id => {
  return axios.get(`sms/sendSms`)
}

export const records = (order_num,vechain_id) => {
  return axios.get(`orders/${order_num}/records/details?vechain_id=${vechain_id}`)
}

export const getLogs = (page,content, size, bdate, edate,type) => {
  return axios.get(`logs?`, {
    params: {
      page: page,
      size: size || defaultPageSize,
      bdate: bdate,
      edate: edate,
      type: type,
      search_content:content,
      t: new Date().getTime()
    }
  })
}

export const logsType = id => {
  return axios.get(`logs/type`)
}

export const getVechainOrders = (page, size) => {
  let params = {
    page: page,
    size: size || defaultPageSize
  }
  return axios.get(`vechain/order/list`, { params: params })
}

export const getVechainProductList = () => {
  return axios.post(`vechain/order/goodsList`, {
    page: 1,
    size: 100
  });
}

export const getVechainProductList2 = () => {
  return axios.get(`vechain/goods/getGoodsList`, {params: {page:1, size:100}});
}

export const createVechainOrder = params => {
  //console.log(params);
  return axios.post(`vechain/order/create`, params);
}

export const createVechainOrder2 = params => {
  //console.log(params);
  return axios.post(`vechain/order/createGoodsOrder`, params);
}

export const confirmVechainOrder = requestNo => {
  return axios.post(`vechain/order/confirm`, {
    requestNo: requestNo
  });
}

export const confirmVechainOrder2 = requestNo => {
  return axios.post(`vechain/order/confirmOrder`, {
    requestNo: requestNo
  });
}

export const importVechainOrderTags = requestNo => {
  return axios.post(`vechain/order/importVID`, {
    requestNo: requestNo
  });
}

export const getLatestVechainOrderAddress = () => {
  return axios.get(`vechain/order/latestaddress`);
}

export const getVechainOrderDetail = requestNo => {
  return axios.post(`vechain/order/query`, {
    requestNo: requestNo
  });
}

export const getVechainOrderDetail2 = requestNo => {
  return axios.post(`vechain/order/getGoodsOrderDetail`, {
    requestNo: requestNo
  });
}


// WEBPACK FOOTER //
// ./src/vuex/svc.js